import axios from 'axios';

const instance = axios.create({
  baseURL: '/',
});

instance.defaults.headers.post['Content-Type'] = 'application/json';
instance.defaults.headers.get['Content-Type'] = 'application/json';
// instance.defaults.headers.get['Access-Control-Allow-Origin'] = '*';
instance.defaults.headers.get.Accept = 'application/json';

export default instance;